module.exports = __webpack_public_path__ + "img/logo.67b79b5f.png";